import { render, staticRenderFns } from "./LoginFlowStepPassword.vue?vue&type=template&id=a1bf6d6a&scoped=true&"
import script from "./LoginFlowStepPassword.vue?vue&type=script&lang=ts&"
export * from "./LoginFlowStepPassword.vue?vue&type=script&lang=ts&"
import style0 from "./LoginFlowStepPassword.vue?vue&type=style&index=0&id=a1bf6d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bf6d6a",
  null
  
)

export default component.exports